import React, { Component } from "react";
import AddIcon from "@material-ui/icons/Add";
import RemoveIcon from "@material-ui/icons/Remove";
import Select from "react-select";
// import { PassengerInformation } from "../../../models/hotel/hotel-search";

class AdultInput extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dateOfBirth: null,
      foucsed: false,
      showFlier: false,
      showRequest: false,
    };
  }
  showFlier = () => {
    let temp = !this.state.showFlier;
    this.setState({ showFlier: temp });
  };
  showRequest = () => {
    let temp = !this.state.showRequest;
    this.setState({ showRequest: temp });
  };
  render() {
    const optionsFlier = [
      { value: "ShebaMiles (ET)", label: "ShebaMiles (ET)" },
      { value: "Aeroplan (AC)", label: "Aeroplan (AC)" },
      { value: "Airpoints (NZ)", label: "Airpoints (NZ)" },
      { value: "Amigo (O6)", label: "Amigo (O6)" },
      { value: "ANA Mileage Club (NH)", label: "ANA Mileage Club (NH)" },
      { value: "Asiana Club (OZ)", label: "Asiana Club (OZ)" },
      { value: "ASKY Club (KP)", label: "ASKY Club (KP)" },
      { value: "ConnectMiles (CM)", label: "ConnectMiles (CM)" },
      { value: "EgyptAir Plus (MS)", label: "VaniEgyptAir Plus (MS)lla" },
      { value: "EuroBonus (SK)", label: "EuroBonus (SK)" },
      { value: "Flying Returns (AI)", label: "Flying Returns (AI)" },
      {
        value: "Infinity MileageLands (BR)",
        label: "Infinity MileageLands (BR)",
      },
      { value: "KrisFlyer (SQ)", label: "KrisFlyer (SQ)" },
      { value: "LifeMiles (AV)", label: "LifeMiles (AV)" },
      { value: "MileagePlus (UA)", label: "MileagePlus (UA)" },
      { value: "Miles & Bonus (A3)", label: "Miles & Bonus (A3)" },
      { value: "Miles & More (LH)", label: "Miles & More (LH)" },
      { value: "Miles & Smiles (TK)", label: "Miles & Smiles (TK)" },
      { value: "PhoenixMiles (CA)", label: "PhoenixMiles (CA)" },
      { value: "Royal Orchid Plus (TG)", label: "Royal Orchid Plus (TG)" },
      { value: "Victoria (TP)", label: "Victoria (TP)" },
      { value: "Voyager (SA)", label: "Voyager (SA)" },
    ];
    const optionsMeal = [
      { value: "Asian Vegeterian Meal", label: "Asian Vegeterian Meal" },
      { value: "KrisFlyer (SQ)", label: "KrisFlyer (SQ)" },
      { value: "LifeMiles (AV)", label: "LifeMiles (AV)" },
      { value: "MileagePlus (UA)", label: "MileagePlus (UA)" },
      { value: "Miles & Bonus (A3)", label: "Miles & Bonus (A3)" },
      { value: "Miles & More (LH)", label: "Miles & More (LH)" },
      { value: "Miles & Smiles (TK)", label: "Miles & Smiles (TK)" },
      { value: "PhoenixMiles (CA)", label: "PhoenixMiles (CA)" },
      { value: "Royal Orchid Plus (TG)", label: "Royal Orchid Plus (TG)" },
      { value: "Bland Meal", label: "Bland Meal" },
      { value: "Diabetic Meal", label: "Diabetic Meal" },
      { value: "Fruit Platter Meal", label: "Fruit Platter Meal" },
      { value: "Gluten Intolerant Meal", label: "Gluten Intolerant Meal" },
      { value: "Hindu Meal", label: "Hindu Meal" },
      { value: "Kosher Meal", label: "Kosher Meal" },

      { value: "Low Calorie Meal", label: "Low Calorie Meal" },
      { value: "Low Fat Meal", label: "Low Fat Meal" },
      { value: "Low Salt Meal", label: "Low Salt Meal" },
      { value: "Moslem Meal", label: "Moslem Meal" },
      { value: "Non-Lactose Meal", label: "Non-Lactose Meal" },
      { value: "No Salt Meat", label: "No Salt Meat" },
      { value: "Raw Vegeterian Meal", label: "Raw Vegeterian Meal" },
      { value: "Sea Food Meal", label: "Sea Food Meal" },
      { value: "Western Vegeterain Meal", label: "Western Vegeterain Meal" },
      { value: "No special meal", label: "No special meal" },
    ];
    const optionsSperialRequest = [
      { value: "Blind Passenger", label: "Blind Passenger" },
      { value: "Deaf Passenger", label: "Deaf Passenger" },
      { value: "Meet and Assist", label: "Meet and Assist" },
      { value: "Medical Case", label: "Medical Case" },
      {
        value: "Wheelchair/Passanger can walk up stairs",
        label: "Wheelchair/Passanger can walk up stairs",
      },
      {
        value: "Wheelchair/Passanger can walk to seat",
        label: "Wheelchair/Passanger can walk to seat",
      },
      {
        value: "Wheelchair/Passanger must be carried",
        label: "Wheelchair/Passanger must be carried",
      },
    ];
    let flierButton = null;
    let requestButton = null;
    let requestInput = null;
    let flierInput = null;
    let customStyles = {
      option: (provided, state) => ({
        ...provided,
        "text-align": "left",
        color: state.isSelected ? "white" : "black",
        width: state.selectProps.width,
        backgroundColor: state.isSelected ? "#4caf50" : "white",
        "&:hover": {
          backgroundColor: "#4caf50",
          color: "white",
        },
      }),
    };
    if (!this.state.showFlier) {
      flierButton = (
        <span style={{ float: "left" }}>
          <AddIcon className="addFlight" onClick={this.showFlier} />
          <span style={{ color: "#72728c" }}>ADD FREQUENT FLIER</span>
        </span>
      );
      flierInput = null;
    } else {
      flierButton = (
        <span style={{ float: "left" }}>
          <RemoveIcon className="minusFlight" onClick={this.showFlier} />
          <span style={{ color: "#72728c" }}>REMOVE FREQUENT FLIER</span>
        </span>
      );
      flierInput = (
        <div className="col-md-12 col-lg-12">
          <div className="row">
            <label for="program" className=" mbr-fonts-style display-7">
              Frequent Flier Program{" "}
            </label>
          </div>
          <div>
            <Select
              options={optionsFlier}
              id={`adult_flier_${this.props.index + 1}`}
              isSearchable={true}
              styles={customStyles}
            />
          </div>
          <label>Frequent Flier Number</label>
          <input
            type="text"
            className="form-control display-7"
            id={`adult_flier_number_${this.props.index + 1}`}
          />
        </div>
      );
    }
    if (!this.state.showRequest) {
      requestButton = (
        <span style={{ float: "right" }}>
          <AddIcon className="addFlight" onClick={this.showRequest} />
          <span style={{ color: "#72728c" }}> ADD SPECIAL REQUEST</span>
        </span>
      );
      requestInput = null;
    } else {
      requestButton = (
        <span style={{ float: "right" }}>
          <RemoveIcon className="minusFlight" onClick={this.showRequest} />
          <span style={{ color: "#72728c" }}> REMOVE SPECIAL REQUEST</span>
        </span>
      );
      requestInput = (
        <div className="col-md-12 col-lg-12">
          <div className="row">
            <label for="program" className=" mbr-fonts-style display-7">
              Meal Preference{" "}
            </label>
          </div>
          <div>
            <Select
              options={optionsMeal}
              id={`adult_meal_${this.props.index + 1}`}
              isSearchable={true}
              styles={customStyles}
            />
          </div>
          <div className="row">
            <label>Special Request</label>
          </div>
          <div>
            <Select
              options={optionsSperialRequest}
              isSearchable={true}
              id={`adult_special_${this.props.index + 1}`}
              isMulti
              styles={customStyles}
            />
          </div>
        </div>
      );
    }
    return (
      <div>
        <hr style={{ border: "1px solid #4caf50" }} />
        <ul className="form-section page-section">
          <li className="form-line" data-type="control_fullname" id="id_4">
            <label
              className="form-label form-label-top form-label-auto"
              id="label_4"
              for="first_4"
            >
              Full Name For Adult {this.props.index + 2}
            </label>
            <div id="cid_4" className="form-input-wide" data-layout="full">
              <div data-wrapper-react="true" className="extended">
                <span
                  className="form-sub-label-container-title"
                  style={{ "vertical-align": "top" }}
                  data-input-type="first"
                >
                  <select
                    required
                    id={`adult_title_${this.props.index + 1}`}
                    className="form-textbox-title"
                    style={{ width: "38px !important" }}
                    onFocus={function (event) {
                      event.target.classList.remove("is-invalid");
                      event.target.classList.remove("is-valid");
                    }}
                  >
                    <option selected disabled value="">
                      Title *
                    </option>
                    <option value="MR">Mr</option>
                    <option value="MRS"> Mrs </option>
                    <option value="MS"> Ms</option>
                  </select>
                  {/* <label
                    className="form-sub-label"
                    for={`adult_title_${this.props.index + 1}`}
                    style={{ "min-height": "13px" }}
                    aria-hidden="false"
                  >
                    Title *
                  </label> */}
                </span>
                <span
                  className="form-sub-label-container"
                  style={{ "vertical-align": "top" }}
                  data-input-type="first"
                >
                  <input
                    type="text"
                    id={`adult_first_name_${this.props.index + 1}`}
                    className="form-textbox"
                    placeholder="First Name *"
                    onChange={function (e) {
                      if (!e.target.value.match(/[A-Za-z]/g)) {
                        e.target.value = "";
                      }
                    }}
                    onKeyDown={function (e) {
                      var keynum;
                      if (window.event) {
                        keynum = e.keyCode;
                      } else if (e.which) {
                        keynum = e.which;
                      }
                      let isValid =
                        (keynum <= 90 && keynum >= 65) ||
                        keynum == 8 ||
                        keynum == 9 ||
                        keynum == 13 ||
                        keynum == 32 ||
                        keynum == 36 ||
                        keynum == 37 ||
                        keynum == 38 ||
                        keynum == 39 ||
                        keynum == 40;

                      if (!isValid) {
                        e.preventDefault();
                      }
                    }}
                    onFocus={function (event) {
                      event.target.classList.remove("is-invalid");
                      event.target.classList.remove("is-valid");
                    }}
                  />
                  {/* <label
                    className="form-sub-label"
                    for={`adult_first_name_${this.props.index + 1}`}
                    style={{ "min-height": "13px" }}
                    aria-hidden="false"
                  >
                    First Name *
                  </label> */}
                </span>
                <span
                  className="form-sub-label-container"
                  style={{ "vertical-align": "top" }}
                  data-input-type="middle"
                >
                  <input
                    type="text"
                    id={`adult_middle_name_${this.props.index + 1}`}
                    className="form-textbox"
                    onChange={function (e) {
                      if (!e.target.value.match(/[A-Za-z]/g)) {
                        e.target.value = "";
                      }
                    }}
                    onKeyDown={function (e) {
                      var keynum;
                      if (window.event) {
                        keynum = e.keyCode;
                      } else if (e.which) {
                        keynum = e.which;
                      }
                      let isValid =
                        (keynum <= 90 && keynum >= 65) ||
                        keynum == 8 ||
                        keynum == 9 ||
                        keynum == 13 ||
                        keynum == 32 ||
                        keynum == 36 ||
                        keynum == 37 ||
                        keynum == 38 ||
                        keynum == 39 ||
                        keynum == 40;

                      if (!isValid) {
                        e.preventDefault();
                      }
                    }}
                    placeholder="Middle Name"
                  />
                  {/* <label
                    className="form-sub-label"
                    for={`adult_middle_name_${this.props.index + 1}`}
                    style={{ "min-height": "13px" }}
                    aria-hidden="false"
                  >
                    Middle Name
                  </label> */}
                </span>
                <span
                  className="form-sub-label-container"
                  style={{ "vertical-align": "top" }}
                  data-input-type="last"
                >
                  <input
                    type="text"
                    id={`adult_last_name_${this.props.index + 1}`}
                    className="form-textbox"
                    placeholder="Last Name *"
                    onChange={function (e) {
                      if (!e.target.value.match(/[A-Za-z]/g)) {
                        e.target.value = "";
                      }
                    }}
                    onKeyDown={function (e) {
                      var keynum;
                      if (window.event) {
                        keynum = e.keyCode;
                      } else if (e.which) {
                        keynum = e.which;
                      }
                      let isValid =
                        (keynum <= 90 && keynum >= 65) ||
                        keynum == 8 ||
                        keynum == 9 ||
                        keynum == 13 ||
                        keynum == 32 ||
                        keynum == 36 ||
                        keynum == 37 ||
                        keynum == 38 ||
                        keynum == 39 ||
                        keynum == 40;

                      if (!isValid) {
                        e.preventDefault();
                      }
                    }}
                    onFocus={function (event) {
                      event.target.classList.remove("is-invalid");
                      event.target.classList.remove("is-valid");
                    }}
                  />
                  {/* <label
                    className="form-sub-label"
                    for={`adult_last_name_${this.props.index + 1}`}
                    style={{ "min-height": "13px" }}
                    aria-hidden="false"
                  >
                    Last Name *
                  </label> */}
                </span>
              </div>
            </div>
          </li>
          <li
            className="form-line form-line-column form-col-2"
            data-type="control_dropdown"
            id="id_3"
          >
            {/* <label
              className="form-label form-label-top"
              for={`adult_gender_${this.props.index + 1}`}
            >
              Gender
            </label> */}
            <div id="cid_3" className="form-input-wide" data-layout="half">
              <select
                required
                className="form-dropdown"
                id={`adult_gender_${this.props.index + 1}`}
                style={{ width: "310px;" }}
                onFocus={function (event) {
                  event.target.classList.remove("is-invalid");
                  event.target.classList.remove("is-valid");
                }}
              >
                <option selected disabled value="">
                  Gender *
                </option>
                <option value="Male">Male</option>
                <option value="Female"> Female </option>
              </select>
            </div>
          </li>
          <li
            className="form-line form-line-column form-col-1"
            data-type="control_birthdate"
            id="id_24"
          >
            {/* <label
              className="form-label form-label-top"
              id="label_24"
              for="input_24"
            >
              Birth Date *
            </label> */}
            <div id="cid_24" className="form-input-wide" data-layout="full">
              <div data-wrapper-react="true">
                <span
                  className="form-sub-label-container"
                  style={{ "vertical-align": "top" }}
                >
                  <select
                    required
                    id={`adult_month_${this.props.index + 1}`}
                    className="form-dropdown"
                    onFocus={function (event) {
                      event.target.classList.remove("is-invalid");
                      event.target.classList.remove("is-valid");
                    }}
                    title="Month of Birth"
                  >
                    <option selected disabled value="">
                      Month *
                    </option>
                    <option value="01"> January </option>
                    <option value="02"> February </option>
                    <option value="03"> March </option>
                    <option value="04"> April </option>
                    <option value="05"> May </option>
                    <option value="06"> June </option>
                    <option value="07"> July </option>
                    <option value="08"> August </option>
                    <option value="09"> September </option>
                    <option value="10"> October </option>
                    <option value="11"> November </option>
                    <option value="12"> December </option>
                  </select>
                  <label
                    className="form-sub-label"
                    id="adult_year_0"
                    id="sublabel_24_year"
                    style={{ "min-height": "13px" }}
                    aria-hidden="false"
                  >
                    Birth Month
                  </label>
                </span>
                <span
                  className="form-sub-label-container"
                  style={{ "vertical-align": "top" }}
                >
                  <select
                    required
                    id={`adult_day_${this.props.index + 1}`}
                    className="form-dropdown"
                    onFocus={function (event) {
                      event.target.classList.remove("is-invalid");
                      event.target.classList.remove("is-valid");
                    }}
                    title="Day of Birth"
                  >
                    <option selected disabled value="">
                      Day *
                    </option>
                    <option value="1"> 1 </option>
                    <option value="2"> 2 </option>
                    <option value="3"> 3 </option>
                    <option value="4"> 4 </option>
                    <option value="5"> 5 </option>
                    <option value="6"> 6 </option>
                    <option value="7"> 7 </option>
                    <option value="8"> 8 </option>
                    <option value="9"> 9 </option>
                    <option value="10"> 10 </option>
                    <option value="11"> 11 </option>
                    <option value="12"> 12 </option>
                    <option value="13"> 13 </option>
                    <option value="14"> 14 </option>
                    <option value="15"> 15 </option>
                    <option value="16"> 16 </option>
                    <option value="17"> 17 </option>
                    <option value="18"> 18 </option>
                    <option value="19"> 19 </option>
                    <option value="20"> 20 </option>
                    <option value="21"> 21 </option>
                    <option value="22"> 22 </option>
                    <option value="23"> 23 </option>
                    <option value="24"> 24 </option>
                    <option value="25"> 25 </option>
                    <option value="26"> 26 </option>
                    <option value="27"> 27 </option>
                    <option value="28"> 28 </option>
                    <option value="29"> 29 </option>
                    <option value="30"> 30 </option>
                    <option value="31"> 31 </option>
                  </select>
                  <label
                    className="form-sub-label"
                    id="adult_year_0"
                    id="sublabel_24_year"
                    style={{ "min-height": "13px" }}
                    aria-hidden="false"
                  >
                    Birth Day
                  </label>
                </span>
                <span
                  className="form-sub-label-container"
                  style={{ "vertical-align": "top" }}
                >
                  <select
                    required
                    id={`adult_year_${this.props.index + 1}`}
                    className="form-dropdown"
                    onFocus={function (event) {
                      event.target.classList.remove("is-invalid");
                      event.target.classList.remove("is-valid");
                    }}
                    title="Year of Birth"
                  >
                    <option selected disabled value="">
                      Year *
                    </option>
                    <option value="2008"> 2008 </option>
                    <option value="2007"> 2007 </option>
                    <option value="2006"> 2006 </option>
                    <option value="2005"> 2005 </option>
                    <option value="2004"> 2004 </option>
                    <option value="2003"> 2003 </option>
                    <option value="2002"> 2002 </option>
                    <option value="2001"> 2001 </option>
                    <option value="2000"> 2000 </option>
                    <option value="1999"> 1999 </option>
                    <option value="1998"> 1998 </option>
                    <option value="1997"> 1997 </option>
                    <option value="1996"> 1996 </option>
                    <option value="1995"> 1995 </option>
                    <option value="1994"> 1994 </option>
                    <option value="1993"> 1993 </option>
                    <option value="1992"> 1992 </option>
                    <option value="1991"> 1991 </option>
                    <option value="1990"> 1990 </option>
                    <option value="1989"> 1989 </option>
                    <option value="1988"> 1988 </option>
                    <option value="1987"> 1987 </option>
                    <option value="1986"> 1986 </option>
                    <option value="1985"> 1985 </option>
                    <option value="1984"> 1984 </option>
                    <option value="1983"> 1983 </option>
                    <option value="1982"> 1982 </option>
                    <option value="1981"> 1981 </option>
                    <option value="1980"> 1980 </option>
                    <option value="1979"> 1979 </option>
                    <option value="1978"> 1978 </option>
                    <option value="1977"> 1977 </option>
                    <option value="1976"> 1976 </option>
                    <option value="1975"> 1975 </option>
                    <option value="1974"> 1974 </option>
                    <option value="1973"> 1973 </option>
                    <option value="1972"> 1972 </option>
                    <option value="1971"> 1971 </option>
                    <option value="1970"> 1970 </option>
                    <option value="1969"> 1969 </option>
                    <option value="1968"> 1968 </option>
                    <option value="1967"> 1967 </option>
                    <option value="1966"> 1966 </option>
                    <option value="1965"> 1965 </option>
                    <option value="1964"> 1964 </option>
                    <option value="1963"> 1963 </option>
                    <option value="1962"> 1962 </option>
                    <option value="1961"> 1961 </option>
                    <option value="1960"> 1960 </option>
                    <option value="1959"> 1959 </option>
                    <option value="1958"> 1958 </option>
                    <option value="1957"> 1957 </option>
                    <option value="1956"> 1956 </option>
                    <option value="1955"> 1955 </option>
                    <option value="1954"> 1954 </option>
                    <option value="1953"> 1953 </option>
                    <option value="1952"> 1952 </option>
                    <option value="1951"> 1951 </option>
                    <option value="1950"> 1950 </option>
                    <option value="1949"> 1949 </option>
                    <option value="1948"> 1948 </option>
                    <option value="1947"> 1947 </option>
                    <option value="1946"> 1946 </option>
                    <option value="1945"> 1945 </option>
                    <option value="1944"> 1944 </option>
                    <option value="1943"> 1943 </option>
                    <option value="1942"> 1942 </option>
                    <option value="1941"> 1941 </option>
                    <option value="1940"> 1940 </option>
                    <option value="1939"> 1939 </option>
                    <option value="1938"> 1938 </option>
                    <option value="1937"> 1937 </option>
                    <option value="1936"> 1936 </option>
                    <option value="1935"> 1935 </option>
                    <option value="1934"> 1934 </option>
                    <option value="1933"> 1933 </option>
                    <option value="1932"> 1932 </option>
                    <option value="1931"> 1931 </option>
                    <option value="1930"> 1930 </option>
                    <option value="1929"> 1929 </option>
                    <option value="1928"> 1928 </option>
                    <option value="1927"> 1927 </option>
                    <option value="1926"> 1926 </option>
                    <option value="1925"> 1925 </option>
                    <option value="1924"> 1924 </option>
                    <option value="1923"> 1923 </option>
                    <option value="1922"> 1922 </option>
                    <option value="1921"> 1921 </option>
                    <option value="1920"> 1920 </option>
                  </select>
                  <label
                    className="form-sub-label"
                    id="adult_year_0"
                    id="sublabel_24_year"
                    style={{ "min-height": "13px" }}
                    aria-hidden="false"
                  >
                    Birth Year
                  </label>
                </span>
              </div>
            </div>
          </li>
          <li
            className="form-line form-line-column form-col-3"
            data-type="control_email"
            id="id_6"
          >
            <label className="form-label form-label-top" id="label_6">
              {flierButton}
            </label>
            <div id="cid_6" className="form-input-wide" data-layout="half">
              {flierInput}
            </div>
          </li>
          <li
            className="form-line form-line-column form-col-4"
            data-type="control_phone"
            id="id_27"
          >
            <label className="form-label form-label-top" id="label_27">
              {requestButton}
            </label>
            <div id="cid_27" className="form-input-wide" data-layout="half">
              {requestInput}
            </div>
          </li>
        </ul>
      </div>
    );
  }
}

export default AdultInput;
